import { Phone, MessageSquare, Mail, MapPin, Clock, Bot } from "lucide-react";
import { PHONE, TEL, SMS, EMAIL, MAILTO, LOCATION } from "@/lib/config";
import { PageHeader } from "@/components/site/shared";
import { QuoteForm } from "@/components/site/QuoteForm";
import { openGhost } from "@/components/site/GhostAI";
import { useContent } from "@/lib/ContentContext";

export default function Contact() {
  const { content } = useContent();
  return (
    <div>
      <PageHeader overline="Get In Touch" title="Contact Us"
        subtitle="Call, text, email, or request a free quote. We'd love to help restore your property's curb appeal." />
      <section className="section-pad">
        <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 lg:grid-cols-[1fr_480px] gap-12">
          <div>
            <h2 className="font-head font-bold text-2xl text-[var(--navy)] uppercase">Veterans Power Wash & Cleaning Services</h2>
            <div className="flex flex-wrap gap-2 mt-3">
              <span className="bg-[var(--red)] text-white text-xs px-3 py-1 rounded-full font-semibold">Veteran-Owned</span>
              <span className="bg-[var(--surface)] text-[var(--navy)] text-xs px-3 py-1 rounded-full font-semibold">Licensed & Insured</span>
              <span className="bg-[var(--surface)] text-[var(--navy)] text-xs px-3 py-1 rounded-full font-semibold">Residential & Commercial</span>
            </div>
            <div className="mt-8 space-y-4">
              <a href={TEL} className="flex items-center gap-4 bg-white border border-gray-100 rounded-2xl p-5 card-shadow btn-lift" data-testid="contact-call">
                <span className="h-12 w-12 rounded-xl bg-[var(--red)]/10 flex items-center justify-center"><Phone className="w-6 h-6 text-[var(--red)]" /></span>
                <span><span className="block text-xs text-gray-400">Call Us</span><span className="font-semibold text-[var(--navy)] text-lg">{PHONE}</span></span>
              </a>
              <a href={SMS} className="flex items-center gap-4 bg-white border border-gray-100 rounded-2xl p-5 card-shadow btn-lift" data-testid="contact-text">
                <span className="h-12 w-12 rounded-xl bg-[var(--action)]/10 flex items-center justify-center"><MessageSquare className="w-6 h-6 text-[var(--action)]" /></span>
                <span><span className="block text-xs text-gray-400">Text Us</span><span className="font-semibold text-[var(--navy)] text-lg">{PHONE}</span></span>
              </a>
              <a href={MAILTO} className="flex items-center gap-4 bg-white border border-gray-100 rounded-2xl p-5 card-shadow btn-lift" data-testid="contact-email">
                <span className="h-12 w-12 rounded-xl bg-[var(--bright)]/10 flex items-center justify-center"><Mail className="w-6 h-6 text-[var(--bright)]" /></span>
                <span><span className="block text-xs text-gray-400">Email Us</span><span className="font-semibold text-[var(--navy)] break-all">{EMAIL}</span></span>
              </a>
              <div className="flex items-center gap-4 bg-white border border-gray-100 rounded-2xl p-5 card-shadow">
                <span className="h-12 w-12 rounded-xl bg-[var(--navy)]/10 flex items-center justify-center"><MapPin className="w-6 h-6 text-[var(--navy)]" /></span>
                <span><span className="block text-xs text-gray-400">Location</span><span className="font-semibold text-[var(--navy)]">{LOCATION}</span></span>
              </div>
              <div className="flex items-center gap-4 bg-white border border-gray-100 rounded-2xl p-5 card-shadow">
                <span className="h-12 w-12 rounded-xl bg-[var(--navy)]/10 flex items-center justify-center"><Clock className="w-6 h-6 text-[var(--navy)]" /></span>
                <span><span className="block text-xs text-gray-400">Business Hours</span><span className="font-semibold text-[var(--navy)]">{content.business_hours || "Contact us for hours"}</span></span>
              </div>
              <button onClick={openGhost} className="w-full flex items-center gap-4 bg-[var(--navy)] text-white rounded-2xl p-5 btn-lift">
                <span className="h-12 w-12 rounded-xl bg-white/10 flex items-center justify-center"><Bot className="w-6 h-6" /></span>
                <span className="text-left"><span className="block text-xs text-white/60">Instant Help</span><span className="font-semibold">Chat with Ghost AI</span></span>
              </button>
            </div>
            <p className="text-sm text-[var(--text-muted)] mt-6">{content.service_area_note}</p>
          </div>

          <div className="lg:sticky lg:top-24 h-fit bg-white border border-gray-100 rounded-2xl card-shadow p-6">
            <h3 className="font-head font-bold text-xl text-[var(--navy)] uppercase mb-4">Request a Free Quote</h3>
            <QuoteForm variant="general" source="contact_page" />
          </div>
        </div>
      </section>
    </div>
  );
}
